<template>
  <main class="staff-page">
    <header class="page-heading">
      <div>
        <div class="page-eyebrow">Рабочее пространство</div>
        <h1>Клиенты</h1>
      </div>
    </header>
    <property-list />
  </main>
</template>

<script setup lang="ts">
import PropertyList from '@/components/PropertyList.vue';
</script>
